import { render, staticRenderFns } from "./search-by-moh-generic-dialog.vue?vue&type=template&id=b5819ab4"
import script from "./search-by-moh-generic-dialog.vue?vue&type=script&lang=js"
export * from "./search-by-moh-generic-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports